// extracted by mini-css-extract-plugin
export var root = "SidebarLayout-module--root--L+eAP";